import { DocumentIcon, FilmIcon, PhotoIcon } from '@heroicons/react/24/outline';
import { Icon } from '@stereograph/teia-system-design/components/Icon';
import { Stack } from '@stereograph/teia-system-design/components/Stack';
import { useAnomalyDocumentContext } from '../../context/AnomalyDocumentContext';

export const AnomalyDocumentBanner = () => {
  const { anomalyDocument } = useAnomalyDocumentContext();
  const typeLower = anomalyDocument.type.toLowerCase();

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      sx={{
        minHeight: 80,
        backgroundColor: 'secondary.light',
        borderRadius: 1,
      }}
    >
      {(typeLower === 'jpg' || typeLower === 'jpeg' || typeLower === 'png') && (
        <Icon component={PhotoIcon} />
      )}
      {typeLower === 'mp4' && <Icon component={FilmIcon} />}
      {typeLower === 'pdf' && <Icon component={DocumentIcon} />}
    </Stack>
  );
};
